/**
 * @file Renders the modal that edits a user's mobile number.
 */

import React, { useState } from "react";

import { UpdateModal } from "@components/Page";
import {
  readUserOperation as readOperation,
  updateMyUserOperation as updateOperation,
} from "@api/services/backstage";

import getUpdateInputs from "./helpers/getUpdateInputs";

const LABEL_ENTITY = "Mobile";
const LABEL_UPDATE = `Edit ${LABEL_ENTITY}`;
const LABEL_SUBMIT = "Continue";

const inputs = getUpdateInputs();
const schema = updateOperation.getSchema(inputs);

type User = Record<string, unknown>;

export type UserMobileUpdateModalHandle = {
  open: (id: string) => void;
};

type Props = {
  modal: React.RefObject<
    UserMobileUpdateModalHandle | Record<string, never>
  >;
  onSuccess: (updatedUser: User) => void;
};

/**
 * Renders the mobile number edit modal for the given user.
 */
const UserMobileUpdateModal = ({ modal, onSuccess }: Props): JSX.Element => {
  const [, setCurrentUser] = useState<User>({});

  /**
   * Stores the user read by the modal before it is edited.
   */
  const onItemRead = (user: User) => setCurrentUser(user);

  const updateModalProps = {
    title: LABEL_UPDATE,
    entity: LABEL_ENTITY,
    modal,
    schema,
    onSuccess,
    operation: updateOperation,
    onItemRead,
    submitLabel: LABEL_SUBMIT,
    readOperation,
  };

  return (
    <UpdateModal {...updateModalProps} />
  );
};

export default UserMobileUpdateModal;
